export const normalizeTags = (values) => {
  const seen = new Set();
  return values.flatMap((value) => String(value || "").split(","))
    .map((value) => value.trim()).filter((value) => {
      const key = value.toLowerCase();
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};
